<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import config from "../../../config/config";
import { debounce } from "../../../state/helpers";

export default {
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 1,
      search: "",
      moment,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedCharger: [],
      },
      chargerList: [],
      makeData: {
        id: "",
        name: "",
        // connector: "",
        // kw: "",
        // acdc: "",
      },
      searchData: debounce(() => {
        this.getVehicleMakes();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "name",
          sortable: true,
          label: "Name",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {
    makeData: {
      name: { required },
      // connector: {},
      // kw: {},
      // acdc: {},
    },
  },
  computed: {
    ...mapGetters("vehicle", [
      "getAllVehicleMake",
      "loading",
      "vehicleMakeCount",
      "pagination",
      "getShowVehicleMake",
      "getUpdateStatus",
    ]),
  },
  mounted() {
    this.getVehicleMakes();
  },
  methods: {
    ...mapActions("vehicle", [
      "getVehicleMake",
      "showVehicleMake",
      "updateVehicleMake",
      "createVehicleMake",
      "deleteVehicleMake",
    ]),
    getVehicleMakes(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getVehicleMake(filters);
    },
    addVehicleMake() {
      this.makeData.name = "";
      // this.makeData.connector = ""; // Reset new field
      // this.makeData.kw = ""; // Reset new field
      // this.makeData.acdc = ""; // Reset new field
      this.$bvModal.show("bv-modal-add-vehicle-make");
    },
    editVehicleMake(make_id) {
      this.resetForm();
      var data = {
        id: make_id,
      };
      this.showVehicleMake(data).then(() => {
        this.makeData.id = this.getShowVehicleMake.id;
        this.makeData.name = this.getShowVehicleMake.name;
        // this.makeData.connector = this.getShowVehicleMake.connector; // Populate new field
        // this.makeData.kw = this.getShowVehicleMake.kw; // Populate new field
        // this.makeData.acdc = this.getShowVehicleMake.acdc; // Populate new field
        this.$bvModal.show("bv-modal-edit-vehicle-make");
      });
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.makeData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.makeData.id);
        fd.append("name", this.makeData.name);
        // fd.append("connector", this.makeData.connector); // Append new field
        // fd.append("kw", this.makeData.kw); // Append new field
        // fd.append("acdc", this.makeData.acdc); // Append new field
        this.updateVehicleMake(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getVehicleMakes();
          }
          this.$bvModal.hide("bv-modal-edit-vehicle-make");
        });
      }
    },
    submitAddForm() {
      this.$v.$touch();
      if (this.$v.makeData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("name", this.makeData.name);
        // fd.append("connector", this.makeData.connector);
        // fd.append("kw", this.makeData.kw);
        // fd.append("acdc", this.makeData.acdc);
        this.createVehicleMake(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getVehicleMakes();
          }
          this.$bvModal.hide("bv-modal-add-vehicle-make");
        });
      }
    },
    deleteVehicleMakes(make_id) {
      if (confirm("Are You Sure to Delete #" + make_id + " Vehicle Make")) {
        const fd = new FormData();
        fd.append("id", make_id);
        this.deleteVehicleMake(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getVehicleMakes();
          }
        });
      }
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getVehicleMakes();
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-2">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">Vehicle Make ({{ vehicleMakeCount }})</h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select class="custom-select" v-model="perPages" @change="searchData()">
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <b-button
                    class="page-title-right btn btn-success btn-rounded mr-2 add-btn"
                    @click="
                      addVehicleMake();
                      $bvModal.show('bv-modal-add-vehicle-make');
                    "
                    ><i class="mdi mdi-plus mr-1"></i>
                    Add Vehicle Make
                  </b-button>
                  <a
                    :href="config.appurl + 'download-vehicle-make-data'"
                    class="btn btn-primary btn-md btn-rounded ml-1"
                  >
                    Download All Data
                  </a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllVehicleMake"
                  :fields="fields"
                  :busy="loading"
                  class="table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="editVehicleMake(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-edit"></i>
                    </b-button>
                    &nbsp;
                    <b-button
                      @click="deleteVehicleMakes(items.item.id)"
                      class="btn btn-danger btn-rounded"
                    >
                      <i class="bx bx-trash"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllVehicleMake.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Vehicle Make Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getVehicleMakes"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- Add vehicle make Model start -->
    <b-modal id="bv-modal-add-vehicle-make" hide-footer @hidden="resetForm">
      <template #modal-title>Add Vehicle Make</template>
      <form action="#" @submit.prevent="submitAddForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Name</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Make Name"
                v-model="$v.makeData.name.$model"
                :class="{ 'is-invalid': $v.makeData.name.$error }"
                name="name"
              />
              <div v-if="$v.makeData.name.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.name.required">Please enter make name</span>
              </div>
            </div>
            <!-- <div class="form-group mb-3">
              <label>Connector</label>
              <input
                id="connector"
                type="text"
                class="form-control"
                placeholder="Enter Connector Type"
                v-model="$v.makeData.connector.$model"
                :class="{ 'is-invalid': $v.makeData.connector.$error }"
                name="connector"
              />
              <div v-if="$v.makeData.connector.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.connector.required">Please enter connector type</span>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>KW</label>
              <input
                id="kw"
                type="text"
                class="form-control"
                placeholder="Enter KW"
                v-model="$v.makeData.kw.$model"
                :class="{ 'is-invalid': $v.makeData.kw.$error }"
                name="kw"
              />
              <div v-if="$v.makeData.kw.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.kw.required">Please enter KW</span>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>AC or DC</label>
              <input
                id="acdc"
                type="text"
                class="form-control"
                placeholder="Enter AC or DC"
                v-model="$v.makeData.acdc.$model"
                :class="{ 'is-invalid': $v.makeData.acdc.$error }"
                name="acdc"
              />
              <div v-if="$v.makeData.acdc.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.acdc.required">Please enter AC or DC</span>
              </div>
            </div> -->
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-add-vehicle-make');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Add vehicle make Model end -->
    <!-- Edit vehicle make Model start -->
    <b-modal id="bv-modal-edit-vehicle-make" hide-footer @hidden="resetForm">
      <template #modal-title>Edit Vehicle Make</template>
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Name</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Make Name"
                v-model="$v.makeData.name.$model"
                :class="{ 'is-invalid': $v.makeData.name.$error }"
                name="name"
              />
              <div v-if="$v.makeData.name.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.name.required">Please enter make name</span>
              </div>
            </div>
            <!-- <div class="form-group mb-3">
              <label>Connector</label>
              <input
                id="connector"
                type="text"
                class="form-control"
                placeholder="Enter Connector Type"
                v-model="$v.makeData.connector.$model"
                :class="{ 'is-invalid': $v.makeData.connector.$error }"
                name="connector"
              />
              <div v-if="$v.makeData.connector.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.connector.required">Please enter connector type</span>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>KW</label>
              <input
                id="kw"
                type="text"
                class="form-control"
                placeholder="Enter KW"
                v-model="$v.makeData.kw.$model"
                :class="{ 'is-invalid': $v.makeData.kw.$error }"
                name="kw"
              />
              <div v-if="$v.makeData.kw.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.kw.required">Please enter KW</span>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>AC or DC</label>
              <input
                id="acdc"
                type="text"
                class="form-control"
                placeholder="Enter AC or DC"
                v-model="$v.makeData.acdc.$model"
                :class="{ 'is-invalid': $v.makeData.acdc.$error }"
                name="acdc"
              />
              <div v-if="$v.makeData.acdc.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.acdc.required">Please enter AC or DC</span>
              </div>
            </div> -->
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-edit-vehicle-make');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Edit vehicle make Model end -->
  </div>
</template>
<style>
.multiselect {
  width: 250px !important;
}
</style>
